import * as React from 'react';
import { SVGProps } from 'react';
const SvgDocumentIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M15.125 10.6875V8.71875C15.125 7.32078 13.9917 6.1875 12.5938 6.1875H11.4688C11.0028 6.1875 10.625 5.80974 10.625 5.34375V4.21875C10.625 2.82078 9.49172 1.6875 8.09375 1.6875H6.6875M8.375 1.6875H4.71875C4.25276 1.6875 3.875 2.06526 3.875 2.53125V15.4688C3.875 15.9347 4.25276 16.3125 4.71875 16.3125H14.2812C14.7472 16.3125 15.125 15.9347 15.125 15.4688V8.4375C15.125 4.70958 12.1029 1.6875 8.375 1.6875Z" stroke="#293B61" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);
export default SvgDocumentIcon;
